(function () {
  var GIFT_RULES = {
    '004154': ['004731', '003866'],
    '005448': ['003867', '004153'],
    '003449': ['004153', '004734'],
    '004150': ['004729', '003867'],
    '004155': ['003867', '004734'],
    '004152': ['003867', '004734'],
    '004145': ['004738', '003867'],
    '005446': ['005447'],
    '004146': ['004729', '004738'], // Royale D'or 100ml → Bliss 30ml + Velvet 30ml
  };

  var GIFT_SKUS = ['003867', '004153', '004734', '004729', '004738', '005447', '004731', '003866'];
  var MIN_SUBTOTAL = 8900; // R$89,00 em centavos

  var CHECKOUT_SELECTORS = '[data-action="open-checkout"], button[name="checkout"], a[href$="/checkout"]';
  var CHECKOUT_TIMEOUT = 2000;

  var DEBOUNCE_DELAY = 600;
  var _timer = null;
  var _running = false;
  var _pending = false;

  function normalizeSku(sku) {
    return (sku || '').replace(/^'/, '').trim();
  }

  // Retorna subtotal pago em centavos (exclui itens com price = 0, ou seja, brindes)
  function getPaidSubtotal(items) {
    return items.reduce(function (sum, item) {
      return item.price > 0 ? sum + item.final_line_price : sum;
    }, 0);
  }

  // Retorna true se o carrinho não está vazio e NENHUM item tem preço base pago
  function isEntirelyFree(items) {
    return items.length > 0 && items.every(function (item) { return item.price === 0; });
  }

  // Desativado temporariamente para o My Soul: o app Dr. Free Gift está em conflito
  // com o GIFT_RULES pra esse produto (um adiciona o brinde, este script remove,
  // loop infinito). Enquanto isso não é realinhado no app, pulamos a verificação
  // inteira quando o My Soul estiver no carrinho, pra não brigar com o app.
  function cartHasMySoul(items) {
    return items.some(function (item) {
      return (item.handle || '').indexOf('my-soul') !== -1;
    });
  }

  // Retorna as line item keys a remover (brindes órfãos, abaixo do mínimo, ou tudo
  // se o carrinho for 100% grátis — protege contra brinde novo ainda não mapeado).
  function computeRemovals(items) {
    if (items.length === 0) return [];
    if (cartHasMySoul(items)) return [];

    if (isEntirelyFree(items)) {
      return items.map(function (item) { return item.key; });
    }

    var triggers = items.filter(function (item) {
      return GIFT_RULES[normalizeSku(item.sku)];
    });

    var gifts = items.filter(function (item) {
      return GIFT_SKUS.indexOf(normalizeSku(item.sku)) !== -1;
    });

    if (gifts.length === 0) return [];

    var paidSubtotal = getPaidSubtotal(items);
    var belowMinimum = paidSubtotal < MIN_SUBTOTAL;

    var allowed = {};
    triggers.forEach(function (item) {
      var permitted = GIFT_RULES[normalizeSku(item.sku)] || [];
      permitted.forEach(function (sku) { allowed[sku] = true; });
    });

    var toRemove = [];
    gifts.forEach(function (item) {
      var sku = normalizeSku(item.sku);
      if (!allowed[sku] || belowMinimum) {
        toRemove.push(item.key);
      }
    });

    return toRemove;
  }

  function removeKeys(keys) {
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ updates: updates }),
    });
  }

  // Atualiza o drawer chamando o método do próprio componente, em vez de disparar
  // o evento público 'cart:refresh' no document — apps de terceiros (ex: Dr. Free
  // Gift) podem escutar esse nome de evento genérico e reagir recriando o brinde
  // que acabamos de remover, causando um loop de add/remove.
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer._onCartRefresh === 'function') {
      drawer._onCartRefresh();
    }
  }

  // Lock: evita duas verificações concorrentes. Se chamado durante uma verificação
  // em andamento, marca "pendente" e roda mais uma vez só ao terminar a atual.
  function runCheck() {
    if (_running) {
      _pending = true;
      return Promise.resolve([]);
    }
    _running = true;

    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var toRemove = computeRemovals(cart.items || []);
        if (toRemove.length === 0) return [];

        return removeKeys(toRemove).then(function () {
          refreshDrawer();
          return toRemove;
        });
      })
      .catch(function () {
        return [];
      })
      .then(function (removed) {
        _running = false;
        if (_pending) {
          _pending = false;
          runCheck();
        }
        return removed;
      });
  }

  function debounce() {
    clearTimeout(_timer);
    _timer = setTimeout(runCheck, DEBOUNCE_DELAY);
  }

  function onCartEvent() {
    debounce();
  }

  // Bloqueio no checkout em capture phase — dispara antes do redirect do tema.
  // Timeout de 2s garante que o checkout nunca trava esperando essa verificação.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(CHECKOUT_SELECTORS);
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var settled = false;
    var timeoutId = setTimeout(function () {
      if (settled) return;
      settled = true;
      window.location.href = '/cart?view=fast';
    }, CHECKOUT_TIMEOUT);

    runCheck()
      .then(function (removed) {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        if (removed.length === 0) {
          window.location.href = '/cart?view=fast';
        }
        // Se removeu algo, fica no carrinho pra mostrar o conteúdo atualizado.
      })
      .catch(function () {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        window.location.href = '/cart?view=fast';
      });
  }, true);

  // Verificação única ao carregar a página (aguarda o Dr. Free Gift inicializar).
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(runCheck, 500);
  });

  document.addEventListener('cart:change', onCartEvent);
  document.addEventListener('cart:refresh', onCartEvent);
})();
